module.exports = __webpack_public_path__ + "img/aero-shot-1.add6389c.webp";